import { combineReducers } from 'redux'
import { createFullCycleHandlers } from 'utils/reducers'
import actions from 'actions/crm/autoCanned'
import crmState from './initial.state'

export default combineReducers({
  conditions: createFullCycleHandlers(actions.conditions, crmState.autoCanned.conditions),
  keywords: createFullCycleHandlers(actions.keywords, crmState.autoCanned.keywords)
})
